import { Button, DropdownMenu } from '@octopus-do/octopus-storybook'
import { Question } from '@octopus-do/octopus-storybook/icons'
import React from 'react'

export const ProjectInfoMenuButton = React.forwardRef<HTMLButtonElement>(
  (_, ref) => {
    const { active, toggle } = DropdownMenu.useTrigger()

    return (
      <Button
        ref={ref}
        priority="secondary"
        size="medium"
        left={Question}
        aria-label="Help"
        active={active}
        onPointerDown={toggle}
      />
    )
  }
)
